import { object, number, string, array } from '@gogame/schemas';

import {
  FILTER_AGENCIES,
  FILTER_MASTER_CAMPAIGNS,
  FILTER_INFLUENCERS,
  FILTER_CATEGORIES,
  FILTER_SUB_CATEGORIES,
  FILTER_SOCIAL_MEDIA_PLATFORMS,
  FILTER_COUNTRIES,
} from 'scenes/Influencers/InfluencersChannels/constants';

export const EMPTY_FILTERS = {};

export const filtersSchema = object({
  [FILTER_AGENCIES]: array(number()),
  [FILTER_MASTER_CAMPAIGNS]: array(number()),
  [FILTER_INFLUENCERS]: array(number()),
  [FILTER_CATEGORIES]: array(number()),
  [FILTER_SUB_CATEGORIES]: array(number()),
  [FILTER_SOCIAL_MEDIA_PLATFORMS]: array(number()),
  [FILTER_COUNTRIES]: array(string()),
});
